(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseStatusDialogController', PurchaseStatusDialogController);

    PurchaseStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchaseStatus'];

    function PurchaseStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchaseStatus) {
        var vm = this;
        vm.purchaseStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchaseStatus.id !== null) {
                PurchaseStatus.update(vm.purchaseStatus, onSaveSuccess, onSaveError);
            } else {
                PurchaseStatus.save(vm.purchaseStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
